@if (
    accountConfirmStatus === eAccountConfirmationStatus.Error ||
    accountConfirmStatus === eAccountConfirmationStatus.LinkExpired
  ) {
<app-expired-token [email]="email" />
}
